import React, { useState, useRef, useEffect } from "react";
import {
  BsFillKeyFill,
  BsFillEyeFill,
  BsFillEyeSlashFill,
  BsFillTelephoneFill,
  BsPersonFill,
} from "react-icons/bs";
import Logo_Dashboard from "../../../Images/Logo_Dashboard.png";
import Rectangle from "../../../Images/Rectangle_368.png";
import undraw_design_tools_ from "../../../Images/undraw_design_tools_-42-tf 1.png";
import generateMathCaptcha from "./generateMathCaptcha";
import { useSelector, useDispatch } from "react-redux";
import {
  checkUserAsync,
  setOTP,
  setPhoneNumber,
  selectError,
  selectLoggedInUser,
  setLoginError,
  clearError,
  checkUserMobileAsync,
  loginWithMobileAsync,
} from "../authSlice";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Captcha from "./Captcha";
import { toast } from "react-toastify";

const OtpInput = ({ onOtpChange, onResendOTP, otpResent, timer }) => {
  const inputs = useRef([]);
  const [allFieldsFilled, setAllFieldsFilled] = useState(false);

  useEffect(() => {
    inputs.current[0].focus();
  }, []);

  const handleChange = (index, e) => {
    const digit = e.target.value.slice(-1);

    if (/^\d$/.test(digit)) {
      inputs.current[index].value = digit;

      for (let i = index + 1; i < inputs.current.length; i++) {
        if (inputs.current[i].value === "") {
          inputs.current[i].focus();
          break;
        }
      }
    } else if (digit === "") {
      inputs.current[index].value = "";
    } else {
      inputs.current[index].value = "";
    }

    const isOtpFilled = inputs.current.every((input) => input.value !== "");
    setAllFieldsFilled(isOtpFilled);
    onOtpChange(inputs.current.map((input) => input.value).join(""));
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (inputs.current[index].value === "" && index > 0) {
        inputs.current[index - 1].focus();
      } else {
        inputs.current[index].value = "";
        e.preventDefault();
      }
    }
  };

  return (
    <div className="container mt-5 flex flex-col items-center">
      <div className="flex mb-3">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="mx-2">
            <input
              type="text"
              maxLength={1}
              className="form-control text-center"
              style={{ width: "40px" }}
              ref={(el) => (inputs.current[index] = el)}
              onChange={(e) => handleChange(index, e)}
              onKeyDown={(e) => handleKeyDown(index, e)}
            />
          </div>
        ))}
      </div>
      {/* Resend OTP button below the first OTP input box */}
      <div className="text-center mb-2">
        {!otpResent && (
          <button onClick={onResendOTP} className="text-blue-500">
            Resend OTP
          </button>
        )}
      </div>
      {/* Timer below the fourth OTP input box */}
      <div className="text-center">
        {otpResent && <p>{timer < 10 ? `00:0${timer}` : `00:${timer}`}</p>}
      </div>
    </div>
  );
};

const Login = () => {
  const dispatch = useDispatch();
  const [resendEmail, setResendEmail] = useState("");
  const [resendPassword, setResendPassword] = useState("");
  const [otpResent, setOtpResent] = useState(false);
  const [timer, setTimer] = useState(10); // Initial timer value
  const error = useSelector(selectError);
  const user = useSelector(selectLoggedInUser);
  const otp = useSelector((state) => state.auth.otp); // Access OTP and phoneNumber from Redux store
  const phoneNumber = useSelector((state) => state.auth.phoneNumber);
  const [enteredOtp, setEnteredOtp] = useState(""); // State to store the entered OTP
  const [showOtpForm, setShowOtpForm] = useState(false);
  const navigate = useNavigate(); // useNavigate hook for navigation
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    getValues,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [error1, setError] = useState("");

  useEffect(() => {
    let interval;
    if (otpResent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setOtpResent(false);
      setTimer(10); // Reset timer
    }
    return () => clearInterval(interval);
  }, [otpResent, timer]);

  const handleLogin = async (data) => {
    if (!captchaRef.current.verifyCaptcha()) {
      setError("CAPTCHA verification failed. Please try again.");
      captchaRef.current.regenerateCaptcha();
      return;
    }

    try {
      const result = await dispatch(
        checkUserAsync({
          email: data.email,
          password: data.password,
        })
      );

      if (result.payload?.token) {
        navigate("/Dashboard");
      } else {
        console.error("Login Failed");
        setError("Login Failed");
        captchaRef.current.regenerateCaptcha();
      }
    } catch (error) {
      setError("Invalid Credential");
      captchaRef.current.regenerateCaptcha();
    }
  };

  const captchaRef = useRef();
  // const handleGetOtp = async (data, e) => {
  //   debugger;
  //   e.preventDefault();
  //   console.log("Mobile number before calling API:", data.mobile);
  //   setError("");
  //   try {
  //     debugger;
  //     const result = await dispatch(checkUserMobileAsync(data.mobile));
  //     debugger;
  //     console.log(result);

  //     if (result.payload.status === 200) {
  //       dispatch(setOTP(result.payload.otp));
  //     } else {
  //       console.error("Login Failed");
  //       setError("Login Failed");
  //     }
  //   } catch (error) {
  //     setError("Invalid Credential");
  //   }
  // };

  const handleGetOtp = async (data, e) => {
    e.preventDefault();
    setError("");

    try {
      const result = await dispatch(checkUserMobileAsync(data.mobile));

      if (result.payload.status === 200) {
        dispatch(setOTP(result.payload.otp));
      } else if (
        result.payload.message === "Please wait before requesting a new OTP."
      ) {
        toast.error(
          "OTP already sent. Please wait 30 seconds before trying again."
        );
      } else {
        console.error("Login Failed");
        setError("Login Failed");
        toast.error("Login Failed");
      }
    } catch (error) {
      setError("Invalid Credential");
      toast.error("Invalid Credential");
    }
  };

  // const handleOTPSubmit = async () => {
  //   debugger;

  //   console.log(otp);
  //   // e.preventDefault();
  //   if (otp === enteredOtp) {
  //     debugger;
  //     try {
  //       toast.success("OTP Verified");
  //       navigate("/Dashboard");
  //       dispatch(setOTP("")); // Navigate to "/dummy" if OTP verification is successful
  //     } catch (error) {
  //       toast.error("Invalid OTP");
  //       console.error("OTP verification failed:", error);
  //     }
  //   } else {
  //     console.error("OTP does not match");
  //   }
  // };

  const handleOTPSubmit = async (data, e) => {
    try {
      // dispatch the new thunk
      const result = await dispatch(
        loginWithMobileAsync({ mobile: data.mobile, otp: enteredOtp })
      ).unwrap();

      // if we reach here, login succeeded
      toast.success("Login successful");
      navigate("/Dashboard");
    } catch (err) {
      toast.error(err.message || "OTP verification failed");
      dispatch(setOTP(""));
    }
  };

  const handleResendOTP = async () => {
    try {
      setOtpResent(true); // Start the timer
      const mobileValue = getValues("mobile"); // Retrieve the mobile number from the form
      if (!mobileValue || !/^[0-9]{10}$/.test(mobileValue)) {
        setError("mobile", {
          type: "manual",
          message: "Enter a valid 10-digit mobile number before resending OTP.",
        });
        setOtpResent(false); // Reset the OTP resend flag
        return;
      }

      const result = await dispatch(checkUserMobileAsync(mobileValue)); // Use phone number from form
      if (result.payload && result.payload.otp) {
        dispatch(setOTP(result.payload.otp)); // Dispatch action to set new OTP
      } else {
        console.error("Resend OTP failed: OTP not found in response.");
        setOtpResent(false); // Reset the OTP resend flag
      }
    } catch (error) {
      console.error("Resend OTP failed:", error);
      setOtpResent(false); // Reset the OTP resend flag
    }
  };

  return (
    <>
      {user && <Navigate to="/Login" replace={true} />}
      <div className="w-full h-screen overflow-hidden">
        <div className="flex h-full">
          <div
            className="relative w-full md:w-1/2 h-full bg-cover bg-center"
            style={{ backgroundImage: `url(${Rectangle})` }}
          >
            <div className="absolute top-0 left-6 right-0 w-full h-full flex flex-col justify-between">
              <nav className="flex items-center bg-transparent p-4">
                <a href="/" className="flex items-center text-dark">
                  <img src={Logo_Dashboard} alt="logo" className="h-16 mr-2" />
                  <div>
                    <h6 className="m-0">Stamp & Registration Department</h6>
                    <p className="m-0 text-xs">Government of Uttarakhand</p>
                  </div>
                </a>
              </nav>
              <div className="flex-grow flex flex-col items-center justify-center mt-15 pt-15">
                <img
                  src={undraw_design_tools_}
                  alt="Overlay Image"
                  className="w-80 z-10"
                />
                <div className="mt-8 ml-4 pl-2 flex justify-start items-center">
                  <div className="md:w-2/3 px-4">
                    <h6>Public Data Entry allows citizen for:</h6>
                    <ol className="list-decimal ml-5">
                      <li>Registering Online username and password</li>
                      <li>Document entry for registration.</li>
                      <li>Upload documents and online payments</li>
                      <li>
                        Online appointments to visit sub-registrar office for
                        document registration
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center w-full md:w-1/2 mt-3 md:mt-0">
            <div
              style={{ backgroundColor: "#E8EFF2" }}
              className="rounded-2xl p-6 shadow-lg  max-w-md"
            >
              {!showOtpForm && (
                <form
                  noValidate
                  className="space-y-6"
                  onSubmit={handleSubmit(handleLogin)}
                >
                  <h6>
                    <b>LOGIN TO YOUR ACCOUNT</b>
                  </h6>
                  <div className="mb-1 mt-1">
                    <label htmlFor="email" className="block text-gray-700">
                      Username/Email
                    </label>
                    <div className="flex items-center border border-gray-300 rounded mt-2">
                      <span className="px-3 text-gray-600">
                        <BsPersonFill />
                      </span>
                      <input
                        id="email"
                        // onChange={(e) => setresendemail(e.target.value)}
                        {...register("email", {
                          required: "Email is required",
                          // pattern: {
                          //   value: /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi,
                          //   message: "Enter a valid email",
                          // },
                        })}
                        type="email"
                        className={`flex-1 py-1 px-4 focus:outline-none ${
                          errors.email
                            ? "border-red-500"
                            : "focus:border-blue-500 border-gray-300"
                        }`}
                      />
                    </div>
                    {errors.email && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.email.message}
                      </p>
                    )}
                  </div>

                  <div className="mb-0">
                    <label htmlFor="password" className="block text-gray-700">
                      Password
                    </label>
                    <div className="flex items-center border border-gray-300 rounded mt-1 relative">
                      <span className="px-3 text-gray-600">
                        <BsFillKeyFill />
                      </span>
                      <input
                        id="password"
                        {...register("password", {
                          required: "Password required",
                        })}
                        type={showPassword ? "text" : "password"}
                        className={`flex-1 py-1 px-4 focus:outline-none ${
                          errors.password
                            ? "border-red-500"
                            : "focus:border-blue-500 border-gray-300"
                        }`}
                      />
                      <button
                        type="button"
                        className="absolute right-3 text-gray-500"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <i className="fas fa-eye-slash"></i>
                        ) : (
                          <i className="fas fa-eye"></i>
                        )}
                      </button>
                    </div>
                    {errors.password && (
                      <p className="text-red-500 text-sm mt-0">
                        {errors.password.message}
                      </p>
                    )}
                  </div>
                  <div className="mb-0 mt-4">
                    <label className="block text-gray-700">CAPTCHA</label>

                    <Captcha ref={captchaRef} />

                    {error1 && <div style={{ color: "red" }}>{error1}</div>}
                  </div>

                  <div className="flex justify-end mb-0s">
                    <a href="/ForgetPassword" className="text-red-500">
                      Forgot Password?
                    </a>
                  </div>

                  <div className="flex justify-between gap-2 mb-0s">
                    <button
                      type="submit"
                      className="w-full py-2 mt-2 bg-blue-500 rounded-xl text-white  hover:bg-blue-600"
                    >
                      Login
                    </button>
                    <button
                      onClick={() => setShowOtpForm(true)}
                      className="w-full py-2 mt-2 bg-red-400 rounded-xl text-white  hover:bg-red-500"
                    >
                      Login With Otp
                    </button>
                  </div>
                  <div className="flex justify-center mt-2">
                    <p>
                      <a href="/SignUp" className="text-blue-500">
                        Create New Account
                      </a>
                    </p>
                  </div>
                </form>
              )}

              {showOtpForm && (
                <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                  <h6 className="flex justify-center items-center">
                    <b>Login With OTP</b>
                  </h6>
                  <div className="flex justify-center items-center">
                    <p className="text-center text-gray-700">
                      Please verify your mobile number via One Time Password
                      (OTP) in order to login.
                    </p>
                  </div>
                  <form
                    noValidate
                    className="space-y-6"
                    onSubmit={handleSubmit(
                      otp ? handleOTPSubmit : handleGetOtp
                    )}
                  >
                    <div className="mb-1 mt-1">
                      <label htmlFor="mobile" className="block text-gray-700">
                        Enter Mobile No.
                      </label>
                      <div className="flex items-center border border-gray-300 rounded mt-2">
                        <span className="px-3 text-gray-600">
                          <BsFillTelephoneFill />
                        </span>
                        <input
                          id="mobile"
                          {...register("mobile", {
                            required: "Mobile number is required",
                            pattern: {
                              value: /^[0-9]{10}$/,
                              message: "Enter a valid 10-digit mobile number",
                            },
                          })}
                          type="text"
                          className={`flex-1 py-1 px-4 focus:outline-none ${
                            errors.mobile
                              ? "border-red-500"
                              : "focus:border-blue-500 border-gray-300"
                          }`}
                        />
                      </div>
                      {errors.mobile && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.mobile.message}
                        </p>
                      )}
                    </div>

                    {error && !otp && (
                      <p className="text-red-500 text-sm mt-1">{error}</p>
                    )}
                    {otp && (
                      <OtpInput
                        onOtpChange={setEnteredOtp}
                        onResendOTP={handleResendOTP}
                        otpResent={otpResent}
                        timer={timer}
                      />
                    )}

                    <div className="flex justify-between gap-2 mb-0s">
                      <button
                        type="submit"
                        className="w-full py-2 mt-4 bg-blue-500 rounded-xl text-white hover:bg-blue-600"
                      >
                        {otp ? "Submit OTP" : "Get OTP"}
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          dispatch(setOTP(""));
                          reset(); // Dispatch setOTP with false
                          setShowOtpForm(false); // Update state to hide OTP form
                        }}
                        className="w-full py-2 mt-4 bg-red-500 rounded-xl text-white hover:bg-red-600"
                      >
                        Login with password
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
